import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { DadosAdicionaisModelo } from '../../models/dados-adicionais-modelo.model';
import { DadosAdicionaisModeloService } from '../../services/dados-adicionais-modelo.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-dados-adicionais-modelo-edit',
  templateUrl: './dados-adicionais-modelo-edit.component.html',
  styleUrls: ['./dados-adicionais-modelo-edit.component.scss']
})
export class DadosAdicionaisModeloEditComponent extends BaseFormComponent<DadosAdicionaisModelo> implements OnInit {

  actionLabel: string = "Novo";
  formErrors: boolean = false;
  form: FormGroup;
  dadosAdicionaisModelo: DadosAdicionaisModelo;
  orgaoList: any[] = [];
  list: any;
  questionListTable: any[] = [];
  formArray: FormArray;
  audit: AtualizacoesAudit;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public dadosAdicionaisModeloService: DadosAdicionaisModeloService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit() {
    this.list = this.activatedRoute.snapshot.data["listQuestion"];
    this.initForm();
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),
      processagencytarget: new FormArray([]),
      questionItem: new FormControl(null),
    })

    if (this.entity) {
      this.actionLabel = "Editar";

      this.form.get('title').setValue(this.entity.title);

      this.audit = {
        process_id: this.entity.id
      };

      if (this.entity?.processagencytarget) {
        this.entity?.processagencytarget.forEach((orgao) => {
          this.getFormArray().push(new FormControl(orgao.agency_id));
        })
      }

      if (this.entity?.questionsList) {
        this.entity?.questionsList.forEach((list) => {
          this.list?.question.forEach((question) => {
            if (list.question_id == question.id) {
              let obj = {
                id: list.id,
                label: question.label,
                question_id: question.id,
                allow: list?.allow_null,
                nro_ord: list?.nro_ord,
                process_id: this.entity.id,
              }
              this.questionListTable.push(obj);
            }
          })
        })
      }
    }
  }

  getFormArray(): FormArray {
    return this.form.get('processagencytarget') as FormArray;
  }

  addNewOrgao() {
    this.getFormArray().push(new FormControl(null));
  }

  removeOrgao(index: number) {
    this.getFormArray().removeAt(index);
  }

  getDataCreate(): DadosAdicionaisModelo {
    this.form.get("questionItem").setValue(null);
    if (this.form.value?.processagencytarget?.length) {
      this.form.value?.processagencytarget.forEach((item, index) => {
        if (!item) {
          this.removeOrgao(index);
        }
      })
    }
    let data: DadosAdicionaisModelo;
    data = Object.assign({}, data, this.form.value);
    data.questions = this.questionListTable;
    data.questions.forEach((item) => {
      item.id = String(item.id);
      item.allow_null = item.allow ? "1" : "0";
    });
    return data;
  }

  validarOrgaoRepetido(): boolean {
    let orgaoList = this.form.value?.processagencytarget;
    if (orgaoList?.length) {
      const orgaoArray = new Set();
      for (const orgao of orgaoList) {
        if (orgaoArray.has(orgao) && orgao) {
          return true;
        }
        orgaoArray.add(orgao);
      }
    }
    return false;
  }

  salvar(): void {
    if (this.form.valid && !this.validarOrgaoRepetido()) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.dadosAdicionaisModeloService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: DadosAdicionaisModelo) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.dadosAdicionaisModeloService.create(this.getDataCreate()).subscribe({
            next: (res: DadosAdicionaisModelo) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/dados-adicionais-modelo/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      }
    }
    else {
      if (this.validarOrgaoRepetido()) {
        this.msgError("Não posso repetir Órgão disponível");
      }
      this.markAsDirty();
    }
  }

  voltar(): void {
    this.navigation.back(['projetos/admin-spgg/dados-adicionais-modelo/list']);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questionListTable, event.previousIndex, event.currentIndex);
    this.questionListTable.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }

  addNewQuestion() {
    let question = this.form.get("questionItem");
    const validarQuestionRepetido = this.questionListTable.some((item) => {
      return (item?.question_id == question.value?.id);
    });

    if (validarQuestionRepetido) {
      this.msgError("Não posso repetir Questão disponível");
    } else {
      if (question.value) {
        let obj = {
          label: question.value.label,
          question_id: question.value.id,
          allow: false,
          process_id: this.entity?.id,
          nro_ord: this.questionListTable?.length,
        }
        this.questionListTable.push(obj);
        question.setValue(null)
      }
    }
  }

  removeQuestion(index: number) {
    this.questionListTable.splice(index, 1);
  }

  openModalClonar() {
    Swal.fire({
      title: 'Clonar processo',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Campo obrigatório!';
        }
      },
      reverseButtons: true,
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Clonar',
      cancelButtonText: 'Cancelar',
      preConfirm: (title) => {
        this.clonar(title)
      },
      allowOutsideClick: () => !Swal.isLoading()
    } as SweetAlertOptions)
  }

  clonar(title) {
    this.loading();
    this.addSub(
      this.dadosAdicionaisModeloService.clone(this.entity?.id, { clone_title: title }).subscribe({
        next: (res) => {
          this.loaded();
          this.msgSuccess('Clonado com sucesso!');
        },
        error: (error) => {
          this.loaded();
          this.msgError('Erro ao clonar!');
        },
      })
    );
  }
}
